import { Component, Input, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import HCNoData from 'highcharts/modules/no-data-to-display';
import { TranslocoService } from '@ngneat/transloco';
import HC_sankey from 'highcharts/modules/sankey';
import HC_depwheel from 'highcharts/modules/dependency-wheel';
import HC_more from 'highcharts/highcharts-more';
import HC_drilldown from 'highcharts/modules/drilldown';
import HC_export from 'highcharts/modules/exporting';
import HC_export_offline from 'highcharts/modules/offline-exporting';

HC_more(Highcharts);
HC_sankey(Highcharts);
HC_depwheel(Highcharts);
HCNoData(Highcharts);
HC_export(Highcharts);
HC_export_offline(Highcharts);
HC_drilldown(Highcharts);


@Component({
  selector: 'app-generic-graph',
  templateUrl: './generic-graph.component.html',
  styleUrls: ['./generic-graph.component.scss']
})
export class GenericGraphComponent implements OnInit {

  public Highcharts: typeof Highcharts = Highcharts;

  @Input() chartType = 'column';
  @Input() dataType = 'datetime';
  @Input() name: string;
  @Input() height = 225;
  @Input() title = '';
  @Input() dataDescription: string = null;
  @Input() tooltipDecimalPlaces = 0;
  @Input() customSeries = false;
  @Input() legend = false;
  @Input() chartInverted = false;
  @Input() chartPolar = false;
  @Input() plotOptions: any = {};
  @Input() drillDown: any = {};
  @Input() categories = undefined;
  @Input() tooltipDateFormat: string = undefined;
  @Input() tooltipShared = false;
  @Input() yAxis: any = { title: { enabled: false } };
  @Input() xAxis: any = undefined;
  @Input() pane: any = {};

  _data: any[];

  public chartOptions;
  public chart;

  constructor(private i18n: TranslocoService) { }

  ngOnInit(): void {
    this.setOptions();
    this.buildGraph();
  }

  @Input()
  public set data(data: any[]) {
    this._data = data;
    setTimeout(() => this.buildGraph(), 0);
  }

  public hcCallback(chart: Highcharts.Chart): void {
    this.chart = chart;
  }

  public getCallbackWithContext(): (chart: Highcharts.Chart) => void {
    return (chart: Highcharts.Chart) => this.hcCallback(chart);
  }

  public resize(): void {
    try {
      setTimeout(() => this.chart.reflow());
    } catch (ignored) {}
  }

  public download(chart: Highcharts.Chart): void {
    chart.exportChartLocal({filename: this.title});
  }

  private buildGraph(): void {
    this.chartOptions = {
      chart: {
        type: this.chartType,
        inverted : this.chartInverted,
        height: this.height,
        zoomType: 'x',
        polar: this.chartPolar,
        resetZoomButton: {
          position: {
            x: 0,
            y: 160
          }
        }
      },
      drilldown: this.drillDown,
      pane: this.pane,
      plotOptions: this.plotOptions,
      title: {
        text: this.title
      },
      xAxis: this.xAxis ? this.xAxis : {
        type: this.dataType,
        categories: this.categories
      },
      yAxis: this.yAxis,
      legend: {
        enabled: this.legend
      },
      tooltip: {
        valueDecimals: this.tooltipDecimalPlaces,
        xDateFormat: this.tooltipDateFormat,
        shared: this.tooltipShared,
        animation: false
      },
      credits: {
        enabled: false
      },
      lang: {
        noData: this.i18n.translate('error.data.noData')
      },
      navigation: {
        buttonOptions: {
          enabled: false
        }
      },
      exporting: {
        filename: this.title,
        sourceWidth: 1200,
        sourceHeight: 400,
      }
    };

    if (this.customSeries) {
      this.chartOptions.series = this._data;
    } else {
      this.chartOptions.series = [{name: this.name, data: this._data}];
    }
  }

  private setOptions(): void {
    Highcharts.setOptions({
      lang: {
        loading: 'Cargando...',
        months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
        shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        rangeSelectorFrom: 'Desde',
        rangeSelectorTo: 'Hasta',
        rangeSelectorZoom: 'Período',
        downloadPNG: 'Descargar imagen PNG',
        downloadJPEG: 'Descargar imagen JPEG',
        downloadPDF: 'Descargar imagen PDF',
        downloadSVG: 'Descargar imagen SVG',
        printChart: 'Imprimir',
        resetZoom: 'Reiniciar zoom',
        resetZoomTitle: 'Reiniciar zoom',
        thousandsSep: '.',
        decimalPoint: ','
      }
    });
  }

}
